module.exports = __webpack_public_path__ + "mh.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mh.svg
// module id = 942
// module chunks = 0